import { useEffect, useCallback, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const IntercomIntegrationPage = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("Verificando...");

    const getCookieValue = useCallback(
        (name) =>
            document.cookie
                .match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")
                ?.pop() || "",
        [],
    );

    const exchangeToken = useCallback(
        async (code) => {
            const response = await fetch(
                `${backendEndpoint}/oauth2/intercom/token/`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": getCookieValue("csrfToken"),
                    },
                    body: JSON.stringify({
                        code: code,
                    }),
                },
            );

            const { status } = await response.json();

            if (status !== "success") {
                setStatus("Erro ao ativar integração. Tente novamente.");
            } else {
                setStatus("Integração ativada com sucesso.");
            }

            window.setTimeout(() => {
                window.opener.dispatchEvent(
                    new Event("intercomIntegrationDone"),
                );
                window.close();
            }, 1000);
        },
        [backendEndpoint, getCookieValue],
    );

    useEffect(() => {
        const code = searchParams.get("code");

        if (!code || !window.opener) {
            navigate("/integrations");
        }

        window.setTimeout(() => {
            exchangeToken(code);
        }, 1000);
    }, [navigate, searchParams, exchangeToken]);

    return (
        <Box
            sx={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 1200,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
            }}
        >
            <Typography variant="h4" gutterBottom>
                Status:
            </Typography>
            <Typography variant="h4" gutterBottom>
                {status}
            </Typography>
        </Box>
    );
};

export default IntercomIntegrationPage;
